import Axios from 'axios';
import { MessageKey } from '@melio/platform-i18n';

export enum OnboardingErrorType {
  Unknown = 'unknown',
  Forbidden = 'forbidden',
  BadRequest = 'badRequest',
}

export type OnboardingError = { type: OnboardingErrorType; code?: string };

export const errorToOnboardingError = (error: unknown): OnboardingError => {
  if (!error || typeof error !== 'object' || !Axios.isAxiosError(error)) {
    return { type: OnboardingErrorType.Unknown };
  }

  const getErrorType = () => {
    switch (error.response?.status) {
      case 400:
        return OnboardingErrorType.BadRequest;
      case 403:
        return OnboardingErrorType.Forbidden;
      default:
        return OnboardingErrorType.Unknown;
    }
  };

  return {
    type: getErrorType(),
    code: error.response?.data?.error?.errorCode,
  };
};

export const onboardingErrorTypeToPathValues = (
  errorType: OnboardingErrorType,
): { title: MessageKey; message: MessageKey } => {
  switch (errorType) {
    case OnboardingErrorType.Forbidden:
      return {
        title: 'widgets.onboarding.errorPage.forbidden.title',
        message: 'widgets.onboarding.errorPage.forbidden.message',
      };
    case OnboardingErrorType.BadRequest:
      return {
        title: 'widgets.onboarding.errorPage.badRequest.title',
        message: 'widgets.onboarding.errorPage.badRequest.message',
      };
    case OnboardingErrorType.Unknown:
    default:
      return {
        title: 'widgets.onboarding.errorPage.unknown.title',
        message: 'widgets.onboarding.errorPage.unknown.message',
      };
  }
};
